import UPButton from './UPButton';

export default UPButton;
